export const ModelsStatus = Object.freeze({
    Active: 0,
    MOC: 1,
    Archived: 2,
})